import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    title: 'Início',
    loadComponent: () => import('./main/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    title: 'Login',
    loadComponent: () => import('./main/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'logout',
    title: 'Logout',
    loadComponent: () => import('./main/logout/logout.component').then(m => m.LogoutComponent)
  },
  {
    path: 'profile',
    title: 'Meu perfil',
    loadComponent: () => import('./main/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [AuthGuardService]
  },
  {
    path: 'documentos/aprovacao',
    title: 'Aprovação de documentos',
    loadComponent: () => import('./main/documentos/documentosaprovacao/documentosaprovacao.component').then(m => m.DocumentosAprovacaoComponent),
    canActivate: [AuthGuardService]
  },
  {
    path: 'compras/catalogo',
    title: 'Compras > Catálogo',
    loadComponent: () => import('./main/compras/catalogo/catalogo.component').then(m => m.CatalogoComponent),
    canActivate: [AuthGuardService]
  },
  {
    path: 'compras/carrinho',
    title: 'Compras > Carrinho',
    loadComponent: () => import('./main/compras/carrinho/carrinho.component').then(m => m.CarrinhoComponent),
    canActivate: [AuthGuardService]
  },
  {
    path: 'compras/pedidos',
    title: 'Compras > Pedidos',
    loadComponent: () => import('./main/compras/pedidos/pedidos.component').then(m => m.PedidosComponent),
    canActivate: [AuthGuardService]
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
